import { useData } from '@app/data/repositories';
import { SearchScreen } from './SearchScreen';
import { useSearch } from './useSearch';
import type { SearchResultItem } from './types';

/**
 * Вход поиска.
 *
 * Куда ведёт результат, решает каркас: экран поиска не знает ни про карточку дела,
 * ни про просмотр документа — иначе `features/search` зависел бы от чужих экранов
 * (ARCHITECTURE.md, правило 4).
 */
export function SearchRoute({
  onBack,
  onOpen,
}: {
  onBack: () => void;
  onOpen: (item: SearchResultItem) => void;
}) {
  const { db } = useData();
  const { state, actions } = useSearch(db);

  return (
    <SearchScreen
      state={state}
      actions={actions}
      onBack={onBack}
      onOpen={(item) => {
        actions.resultOpened();
        onOpen(item);
      }}
    />
  );
}
